<template>
    <div class="sa-prescrizione-card">
        <div class="sa-prescrizione-header">
            <div class="header-left">
                <div class="sa-prescrizione-header-title">Terapia Farmacologica</div>
                <div class="sa-prescrizione-header-subtitle">Prescrizione</div>
            </div>
            <div class="header-right">
                <div style="height: 100% !important; margin-bottom: 2px">
                    <div class="sa-prescrizione-header-title" style="margin-bottom: 2px; font-size: 12px">Modalita
                        Somministrazione</div>
                    <select class="sa-prescrizione-input-header" v-model="viaSomministrazione">
                        <option v-for="misura of prescrizioneModalitaSomministrazioneOptions" :key="misura.id"
                            :value="misura.nome">
                            {{ misura.nome }} <span v-if="!!misura.descrizione"></span>
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="sa-prescrizione-body">
            <div v-for="(item, index) in prescription.components" :key="index"
                class="sa-prescrizione-item sa-prescrizione-item-farmaco">
                <div class="sa-prescrizione-input-group" style="flex: 0">
                    <!-- <input class="sa-prescrizione-input" v-model="item.drugName" placeholder="Cerca farmaco..." /> -->
                    <span
                        style="display: flex; display: inline-flex; align-items: center; justify-content: center; width: 20px; height: 20px; border: 1px solid var(--bg-sidebar); border-radius: 50%; color: var(--bg-sidebar); font-size: 11px; font-weight: bold; flex-shrink: 0; line-height: 1">{{
                            index + 1 }}</span>
                </div>
                <div class="sa-prescrizione-input-group" style="flex: 3">
                    <label class="sa-label-data">Farmaco</label>
                    <!-- <input class="sa-prescrizione-input" v-model="item.drugName" placeholder="Cerca farmaco..." /> -->
                    <div class="sa-prescrizione-search-wrapper">
                        <input class="sa-prescrizione-input sa-prescrizione-input-readonly" v-model="item.prescrizione"
                            readonly placeholder="Seleziona un farmaco..." />

                        <button @click="openRicercaFamraco(index)" class="sa-prescrizione-btn-search"
                            title="Cerca in Federfarma">
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                </div>

                <div class="sa-prescrizione-input-group" style="flex: 1; min-width: 70px">
                    <label class="sa-label-data">Dose</label>
                    <input class="sa-prescrizione-input" type="number" v-model="item.quantita" />
                </div>

                <div class="sa-prescrizione-input-group" style="flex: 1; min-width: 70px">
                    <label class="sa-label-data">Unità</label>
                    <select class="sa-prescrizione-input" v-model="item.unitaMisura"
                        @change="onChangeValueUnitaMisura(item)">
                        <option :value="null">- Seleziona -</option>
                        <option v-for="misura of magazzinoArticoliUnitaMisuraBaseOptions" :key="misura.id"
                            :value="misura.id">{{ misura.descrizioneMultiplo }}</option>
                    </select>
                </div>
                <div class="sa-prescrizione-input-group" style="flex: 1; min-width: 70px">
                    <label class="sa-label-data">Note</label>
                    <input class="sa-prescrizione-input" type="text" v-model="item.note" />
                </div>

                <button v-if="!item.veicolo" @click="removeComponent(index)" class="sa-prescrizione-btn-remove">
                    <i class="fas fa-trash-alt"></i>
                </button>
            </div>

            <button @click="onClickAggiungiFarmaco" class="sa-prescrizione-btn-add"><i class="fas fa-plus"></i> Aggiungi
                farmaco alla prescrizione</button>
        </div>

        <div class="sa-prescrizione-footer">
            <div class="sa-prescrizione-total-text">
                <!-- Volume Finale: <span class="sa-prescrizione-total-value">{{ totalVolume }} ml</span> -->
            </div>
            <button @click="onClickConfermaPrescrizione" class="sa-prescrizione-btn-confirm">Conferma
                Prescrizione</button>
        </div>
    </div>
</template>

<script>
import toast from "../../../../template/layout/utility/sa-toast";
import MagazzinoMixins from "../../../magazzino/mixins/MagazzinoMixins";
import RsaPazientePrescrizioneMixin from "../mixins/RsaPazientePrescrizioneMixin";
export default {
    mixins: [MagazzinoMixins, RsaPazientePrescrizioneMixin],
    data() {
        return {
            totalVolume: "",
            selectedIndex: null,
            viaSomministrazione: "NON DEFINITA",
            prescriptionConfirm: null,
            prescrizione: null,
            prescription: {
                components: [{ formaFarmaceutica: null, codiceProdotto: null, atcGmp: null, prescrizione: null, quantita: 0, unitaMisura: null, unitaMisuraDescrizione: null, costo: 0.0, veicolo: false }],
            },
        };
    },
    mounted() {
        this.mangazzinoArticoliUnitaMisuraLoadData();
        this.rsaPazientePrescrizioniLoad();
    },
    methods: {
        onClickAggiungiFarmaco() {
            this.prescription.components.push({
                formaFarmaceutica: null,
                codiceProdotto: null,
                atcGmp: null,
                prescrizione: "",
                quantita: 0,
                unitaMisura: null,
                costo: 0.0,
                veicolo: false,
            });
        },
        onChangeValueUnitaMisura(item) {
            let unitaMisura = this.magazzinoArticoliUnitaMisuraBaseOptions.filter((e) => e.id == item.unitaMisura);
            if (unitaMisura[0]) item.unitaMisuraDescrizione = unitaMisura[0].descrizioneMultiplo;
        },
        openRicercaFamraco(index) {
            this.selectedIndex = index;
            this.$emit("openRicercaFamraco");
        },
        setSelectionFarmaco(schedaFarmaco) {
            this.prescription.components[this.selectedIndex].codiceProdotto = schedaFarmaco.codiceProdotto;
            this.prescription.components[this.selectedIndex].atcGmp = schedaFarmaco.atcGmp;
            this.prescription.components[this.selectedIndex].costo = schedaFarmaco.euroPrezzo1;
            this.prescription.components[this.selectedIndex].formaFarmaceutica = schedaFarmaco.formaFarmaceutica.descrizione;
            this.prescription.components[this.selectedIndex].prescrizione = schedaFarmaco.descrizione;
            let doseUnita = this.parseDrugDose(schedaFarmaco.descrizione);
            //this.prescription.components[this.selectedIndex].quantita = doseUnita.value;

            this.prescription.components[this.selectedIndex].unitaMisura = doseUnita.unit;
        },
        checkIsVehicle(atcCode) {
            if (!atcCode) return false;
            const code = atcCode.toUpperCase();
            const vehiclePrefixes = ["V07AB", "B05B", "B05A"];
            return vehiclePrefixes.some(function (prefix) {
                return code.startsWith(prefix);
            });
        },
        parseDrugDose(description) {
            if (!description) return { value: 0, unit: null };

            var regex = /(\d+(?:[.,]\d+)?)\s*(ML|MG|G|MEQ|UI)/i;
            var match = description.match(regex);

            if (match) {
                return {
                    value: parseFloat(match[1].replace(",", ".")),
                    unit: match[2].toLowerCase(),
                };
            }
            return { value: 0, unit: null };
        },
        removeComponent: function (index) {
            this.prescription.components.splice(index, 1);
        },
        onClickConfermaPrescrizione(bvModalEvent) {
            bvModalEvent.preventDefault();
            let validation = this.validazione();
            if (!validation.esito) {
                toast.validation(validation);
                return;
            } else {
                this.$emit("erroreValidazione");
            }

            this.$emit("confermaPrescrizione", this.prescription.components, { viaSomministrazione: this.viaSomministrazione });
            toast.success("Farmaci Confermati");
        },
        setFarmaci(prescrizioneFarmaci, jsonPrescrizione) {
            this.prescription.components = JSON.parse(JSON.stringify(prescrizioneFarmaci));
            this.jsonPrescrizione = jsonPrescrizione;
            this.viaSomministrazione = jsonPrescrizione.viaSomministrazione;
        },
        validazione() {
            let esito = true;
            let msg = "";
            if (this.viaSomministrazione == null) {
                msg += "Inserire Modalita Somministrazione #";
                esito = false;
            }
            this.prescription.components.forEach((farmaco, i) => {
                if (!farmaco.prescrizione || farmaco.prescrizione.trim() == "") {
                    msg += "Inserire farmaco valido, indice: " + (i + 1) + " #";
                    esito = false;
                }
                if (farmaco.quantita <= 0 && !isNaN(farmaco.quantita)) {


                    msg += "Inserire quantita valida, indice : " + (i + 1) + " #";
                    esito = false;
                }
                if (farmaco.unitaMisura == null) {
                    msg += "Inserire unita' misura valida, indice : " + (i + 1) + " #";
                    esito = false;
                }
            });



            return { esito: esito, msg: msg };
        },
    },
};
</script>

<style scoped>
.header-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 12px;
    height: 100%;
}

.sa-prescrizione-input-header {
    padding: 8px 12px;
    border-radius: 8px;
    border: none;
    font-weight: 600;
    background-color: rgba(255, 255, 255, 0.15);
    color: white;
    backdrop-filter: blur(6px);
}

.sa-prescrizione-input-header-custom {
    padding: 8px 12px;
    border-radius: 8px;
    border: none;
    font-weight: 600;
    background-color: rgba(255, 255, 255, 0.15);
    color: white;
    backdrop-filter: blur(6px);
    width: 50%;
}

.sa-prescrizione-input-header option {
    color: black;
}

.time-picker {
    min-width: 110px;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid #cbd5e1;
    background: #ffffff;
    font-weight: 700;
    font-size: 14px;
    color: #0f172a;
}

.time-picker:focus-within {
    border-color: #1e40af;
    box-shadow: 0 0 0 2px rgba(30, 64, 175, 0.15);
}

.time-picker .mx-icon-calendar,
.time-picker .mx-icon-time {
    color: #1e40af;
}

.time-picker:hover {
    background: #f8fafc;
}

.sa-prescrizione-input-header-custom::placeholder {
    color: white;

    opacity: 1;
}
</style>
